<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-content>
    <span *nfLoader="corporateActionDetailsLoading">
      <nf-table-layout
        class="detailsTable"
        hideTitle
        [isSectionTitle]="true"
        [gridOptions]="corporateActionOptions"
        [data]="corporateActionRowData"
        hideClearAll
        hideSearch
      >
      </nf-table-layout>
    </span>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
